import type { EquipmentDataQueryCache } from '../api';
import type { ShortInventoryDto } from '@entities/equipmentInventory/@x/equipment';

export const updateShortInventoryInCache = ({
    previous,
    warehouseId,
    inventoryGuid,
    patch,
}: {
    previous: EquipmentDataQueryCache | undefined;
    warehouseId: number;
    inventoryGuid: string;
    patch: Partial<ShortInventoryDto>;
}): EquipmentDataQueryCache | undefined => {
    if (!previous?.data.response.equipment) {
        return previous;
    }

    return {
        ...previous,
        data: {
            ...previous.data,
            response: {
                ...previous.data.response,
                equipment: previous.data.response.equipment.map((warehouse) => {
                    if (warehouse.id !== warehouseId) {
                        return warehouse;
                    }

                    return {
                        ...warehouse,
                        items: warehouse.items.map((item) =>
                            item.guid === inventoryGuid ? { ...item, ...patch } : item
                        ),
                    };
                }),
            },
        },
    };
};
